import React from "react";

const Menubar = (props) => {
  return (
    <svg
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0.710985C0 0.52242 0.0737498 0.341578 0.205025 0.208243C0.336301 0.0749072 0.514348 0 0.7 0H13.3C13.4857 0 13.6637 0.0749072 13.795 0.208243C13.9263 0.341578 14 0.52242 14 0.710985C14 0.89955 13.9263 1.08039 13.795 1.21373C13.6637 1.34706 13.4857 1.42197 13.3 1.42197H0.7C0.514348 1.42197 0.336301 1.34706 0.205025 1.21373C0.0737498 1.08039 0 0.89955 0 0.710985ZM0 4.99964C0 4.81108 0.0737498 4.63024 0.205025 4.4969C0.336301 4.36357 0.514348 4.28866 0.7 4.28866H13.3C13.4857 4.28866 13.6637 4.36357 13.795 4.4969C13.9263 4.63024 14 4.81108 14 4.99964C14 5.18821 13.9263 5.36905 13.795 5.50239C13.6637 5.63572 13.4857 5.71063 13.3 5.71063H0.7C0.514348 5.71063 0.336301 5.63572 0.205025 5.50239C0.0737498 5.36905 0 5.18821 0 4.99964ZM0.7 8.57803C0.514348 8.57803 0.336301 8.65294 0.205025 8.78627C0.0737498 8.91961 0 9.10045 0 9.28902C0 9.47758 0.0737498 9.65842 0.205025 9.79176C0.336301 9.92509 0.514348 10 0.7 10H13.3C13.4857 10 13.6637 9.92509 13.795 9.79176C13.9263 9.65842 14 9.47758 14 9.28902C14 9.10045 13.9263 8.91961 13.795 8.78627C13.6637 8.65294 13.4857 8.57803 13.3 8.57803H0.7Z"
        fill={props.color}
      />
    </svg>
  );
};

export default Menubar;
